function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_430",
  "data-name": "Ret\\xE2ngulo 430",
  width: 6,
  height: 48,
  transform: "translate(21)",
  fill: "#7a8e9b"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_431",
  "data-name": "Ret\\xE2ngulo 431",
  width: 26.25,
  height: 2.25,
  transform: "translate(10.875 45.75)",
  fill: "#525c6b"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7503",
  "data-name": "Caminho 7503",
  d: "M0,12.751l14.506,8.377V18H48V7.5H14.506V4.375Z",
  fill: "#ffbd66"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7504",
  "data-name": "Caminho 7504",
  d: "M33.493,25.5H0V36H33.493v3.126L48,30.754,33.493,22.376Z",
  fill: "#59c5ef"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_432",
  "data-name": "Ret\\xE2ngulo 432",
  width: 19.563,
  height: 1.5,
  transform: "translate(21.001 9.938)",
  fill: "#525c6b"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_433",
  "data-name": "Ret\\xE2ngulo 433",
  width: 16.125,
  height: 1.5,
  transform: "translate(21 14.063)",
  fill: "#525c6b"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_434",
  "data-name": "Ret\\xE2ngulo 434",
  width: 19.563,
  height: 1.5,
  transform: "translate(7.437 27.939)",
  fill: "#525c6b"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_435",
  "data-name": "Ret\\xE2ngulo 435",
  width: 13.563,
  height: 1.5,
  transform: "translate(7.437 32.064)",
  fill: "#525c6b"
});

var SvgTransferIcon = function SvgTransferIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "transfer-icon",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransferIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfer-icon.215e4907.svg";
export { ForwardRef as ReactComponent };